<template>
  <v-app>
   <v-main class="background">

      <v-container max-width="900" class="text-body-1">
  
  <h1 class="mb-6 schrift text-decoration-underline font-weight-bold">
    Kindertagesstätten
  </h1>

  <p>
    Kein Lehrbuch.
    Sondern Alltag.
    Und Lösungen, die darin funktionieren.
  </p>

  <p>
    Eine Kindertagesstätte ist ein lebendiger Ort.
    Kinder spielen, lernen, entdecken die Welt – und nicht alles folgt einem festen Ablauf.
  </p>

  <p>
    Gleichzeitig braucht es Strukturen, die verlässlich funktionieren.
    Auch im Bereich Hygiene.
  </p>

  <p>
    Vieles läuft selbstverständlich.
    Teams arbeiten sorgfältig, Abläufe sind eingespielt.
    Und trotzdem entstehen immer wieder Unsicherheiten.
  </p>

  <p>
    Nicht, weil etwas falsch gemacht wird,
    sondern weil nicht immer klar ist,
    was im Alltag wirklich entscheidend ist
    und wie Anforderungen sinnvoll umgesetzt werden können.
  </p>

<p>&nbsp;</p>

  <p class="mt-6">
    <strong>Genau dort setzen wir an.</strong>
  </p>

  <p>
    Wir bringen Struktur in bestehende Abläufe
    und schaffen Klarheit, die im Alltag trägt.
  </p>

  <p>
    Nicht als zusätzlicher Aufwand,
    sondern als Teil eines funktionierenden Gesamtsystems.
  </p>

  <p>
    Hygiene wird so organisiert,
    dass sie mitläuft.
    Unaufgeregt, verständlich
    und verlässlich – auch dann, wenn es lebendig wird.
  </p>

  <p>
    So entsteht Sicherheit im Alltag.
    Für das Team, für die Abläufe
    und für die Einrichtung insgesamt.
  </p>

  <p>
    Wir arbeiten ruhig und gemeinsam.
    Schauen hin, klären, ordnen.
  </p>

  <p>
    Ohne Druck.
    Ohne zusätzliche Komplexität.
  </p>

  <p>
    Am Ende steht kein Papierkonzept,
    sondern ein System, das alle verstehen
    und das die Zusammenarbeit im Team spürbar erleichtert.
  </p>



 

</v-container>
    </v-main>
  </v-app>
</template>

<script setup>



</script>

<style>

</style>

